import { Phone, Mail, MapPin, MessageCircle, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PHONE, PHONE_TEL, EMAIL, WHATSAPP_DISPLAY, waUrl, GOOGLE_REVIEWS_URL, SOCIAL } from "../data";
import { scrollToId } from "../lib/scroll";

const scrollTo = scrollToId;

export const Footer = () => {
  return (
    <footer className="bg-ink text-white pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-3 gap-12 border-b border-white/10 pb-14">
          <div>
            <Logo variant="light" size={34} />
            <p className="text-white/60 mt-5 text-sm leading-relaxed max-w-xs">
              Carpintería de PVC y aluminio. Iván Hondal López. Ventanas de PVC y aluminio en
              Cantabria, con acabados de calidad y cuidando cada detalle de tu hogar.
            </p>
            <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-block mt-5 text-electric text-sm font-semibold hover:underline underline-offset-4" data-testid="footer-google-link">
              Déjanos tu reseña en Google →
            </a>
            {(SOCIAL.facebook || SOCIAL.instagram) && (
              <div className="flex items-center gap-3 mt-6">
                {SOCIAL.facebook && (
                  <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="grid place-items-center w-10 h-10 border border-white/20 text-white/80 hover:bg-electric hover:border-electric hover:text-white transition-colors">
                    <Facebook size={18} />
                  </a>
                )}
                {SOCIAL.instagram && (
                  <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="grid place-items-center w-10 h-10 border border-white/20 text-white/80 hover:bg-electric hover:border-electric hover:text-white transition-colors">
                    <Instagram size={18} />
                  </a>
                )}
              </div>
            )}
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-white/50 font-bold mb-5">Navegación</h4>
            <ul className="space-y-3">
              {[["nosotros", "Sobre nosotros"], ["servicios", "Servicios"], ["galeria", "Galería"], ["testimonios", "Reseñas"], ["contacto", "Contacto"]].map(([id, label]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="text-white/70 hover:text-electric transition-colors text-sm">{label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-white/50 font-bold mb-5">Contacto</h4>
            <ul className="space-y-4 text-sm text-white/70">
              <li><a href={`tel:${PHONE_TEL}`} className="flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} className="text-electric" /> {PHONE}</a></li>
              <li><a href={waUrl()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors"><MessageCircle size={16} className="text-electric" /> WhatsApp · {WHATSAPP_DISPLAY}</a></li>
              <li><a href={`mailto:${EMAIL}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail size={16} className="text-electric" /> {EMAIL}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="text-electric mt-0.5 shrink-0" /> <span>Renedo de Piélagos · Servicio a domicilio en toda Cantabria</span></li>
            </ul>
          </div>
        </div>

        <p className="text-white/35 text-xs leading-relaxed py-6 border-b border-white/10">
          Ventanas de PVC en Cantabria · Ventanas de aluminio en Cantabria · Conversión a
          oscilobatiente · Mosquiteras a medida · Cerramientos de aluminio · Cerramientos de
          PVC · Persianas · Estores · Cerrajería · Reparación de ventanas · Instalación de
          puertas de PVC y aluminio.
        </p>

        <div className="pt-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Ventanas Hondal · Iván Hondal López.</span>
          <div className="flex items-center gap-5">
            <Link to="/aviso-legal" data-testid="footer-legal-link" className="hover:text-electric transition-colors">Aviso legal</Link>
            <Link to="/privacidad" data-testid="footer-privacy-link" className="hover:text-electric transition-colors">Política de privacidad</Link>
            <span>Cantabria, España</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
